import React from 'react';

const Select = ({ defaultValue, items, placeholder, value, onValueChange, disabled }) => {
	return (
		<div className="flex items-center gap-x-4 border border-gray3 bg-white rounded-md h-10 w-full text-sm">
			<select
				className="flex-1 outline-none border-none bg-transparent px-2 mr-2 w-full"
				placeholder={placeholder ?? 'Seleccione'}
				defaultValue={defaultValue}
				onChange={e => onValueChange(e.target.value)}
				value={value}
				disabled={disabled}
			>
				<option value="" disabled>{ placeholder ?? 'Seleccione' }</option>
				{items.map((item, index) => (
					<option key={index} value={item.value}>{ item.label }</option>
				))}
			</select>
		</div>
	);
}

export default Select;